module.exports = __webpack_public_path__ + "static/media/photo56.3dd87895.jpg";